import { ShieldCheck } from "lucide-react";
import SafetyRulesContent, { SAFETY_RULES_VERSION } from "@/components/SafetyRulesContent";

export { SAFETY_RULES_VERSION };

export default function SafetyRules() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="safety-rules-page">
      <div className="bg-white/80 border border-sage/20 rounded-3xl p-6 sm:p-10 shadow-sm">
        <div className="flex items-center gap-2 mb-2">
          <ShieldCheck className="w-5 h-5 text-sage-dark" />
          <p className="text-xs font-bold uppercase tracking-wide text-forest/60" data-testid="safety-rules-version">
            Safety rules · v{SAFETY_RULES_VERSION}
          </p>
        </div>
        <h1 className="text-3xl sm:text-4xl font-black text-forest mb-6" data-testid="safety-rules-heading">
          Compass Kids Safety Rules
        </h1>

        <SafetyRulesContent variant="page" testIdPrefix="safety-rules-page" />

        <p className="text-xs text-forest/50 mt-10">
          Questions? Email <a href="mailto:info@compasskids.co.za" className="font-bold hover:underline">info@compasskids.co.za</a>.
        </p>
      </div>
    </div>
  );
}
